import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  DialogActions,
  Tab,
  Tabs,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { capitalize } from "../../common/component/util";
import CloseIcon from "@mui/icons-material/Close";

// Baker-app FIELDS constant
const FIELDS = {
  flavor: { name: "Flavor", description: "", rank: 8, required: true, field: { type: "select", min: 1, max: 1, options: [] } },
  filling: { name: "Filling", description: "", rank: 7, required: true, field: { type: "select", min: 1, max: 1, options: [] } },
  icing: { name: "Frosting", description: "", rank: 5, required: true, field: { type: "select", min: 1, max: 1, options: [] } },
  inscription: {
    name: "Inscription",
    description: `Add a greeting like "Happy Birthday", a name like "Alice" or a number like "4"`,
    rank: 1,
    required: false,
    field: { type: "text", min: 0, max: 40 }
  },
  notes: {
    name: "Notes",
    description: "At our discretion, we will try to accommodate your request on a best-effort basis.",
    rank: 0,
    required: false,
    field: { type: "text", min: 0, max: 100 }
  }
};

export default function AddField(props) {
  const { disabled } = props;

  const [tab, setTab] = useState("select");

  const [field, setField] = useState("");

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (tab === "custom") {
      setField({ name: "", description: "", rank: 5, required: true, field: { type: "select", min: 1, max: 1, options: [] } });
    }
  }, [tab]);

  const handleClose = () => {
    setField("");
    setTab("select");
    setOpen(false);
  };

  return (
    <span>
      <IconButton onClick={() => setOpen(true)}>
        <AddIcon />
      </IconButton>
      {open && (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
          <DialogTitle>
            Add Field
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box>
              <Tabs value={tab} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
                <Tab value="select" label={"Selection"} onClick={() => setTab("select")} />
                <Tab value="text" label={"Text"} onClick={() => setTab("text")} />
                <Tab value="custom" label={"Custom"} onClick={() => setTab("custom")} />
              </Tabs>
              {tab === "select" && (
                <Box>
                  <Box py={2}>
                    <Typography variant="body1" color="textSecondary">
                      Selection fields allow customer to choose from a list of options.
                    </Typography>
                  </Box>
                  <RadioGroup
                    value={field?.name || ""}
                    name="field"
                    onChange={(e) => {
                      setField(Object.values(FIELDS).filter((o) => o.name === e.target.value)[0]);
                    }}
                    style={{ justifyContent: "center" }}
                  >
                    {Object.entries(FIELDS)
                      .filter(([key, value]) => value.field.type === "select")
                      .map(([key, value]) => (
                        <FormControlLabel
                          disabled={disabled.includes(key)}
                          value={value.name}
                          control={<Radio required={true} />}
                          label={capitalize(value.name)}
                        />
                      ))}
                  </RadioGroup>
                </Box>
              )}
              {tab === "text" && (
                <Box>
                  <Box py={2}>
                    <Typography variant="body1" color="textSecondary">
                      Text fields allow customer to type something (e.g. a message or an instruction)
                    </Typography>
                  </Box>
                  <RadioGroup
                    value={field?.name || ""}
                    name="field"
                    onChange={(e) => {
                      setField(Object.values(FIELDS).filter((o) => o.name === e.target.value)[0]);
                    }}
                    style={{ justifyContent: "center" }}
                  >
                    {Object.entries(FIELDS)
                      .filter(([key, value]) => value.field.type === "text")
                      .map(([key, value]) => (
                        <FormControlLabel
                          disabled={disabled.includes(key)}
                          value={value.name}
                          control={<Radio required={true} />}
                          label={capitalize(value.name)}
                        />
                      ))}
                  </RadioGroup>
                </Box>
              )}
              {tab === "custom" && (
                <Box>
                  <Box py={2}>
                    <Typography variant="body1" color="textSecondary">
                      Custom fields allow to create a selection field for your specific needs
                    </Typography>
                  </Box>
                  <Box>
                    <TextField
                      id="name"
                      value={field?.name}
                      label="Name"
                      name="name"
                      variant="outlined"
                      fullWidth
                      required
                      onChange={(e) => setField({ ...field, name: e.target.value })}
                      inputProps={{ maxLength: 25 }}
                      helperText="A short name, 1-2 words max."
                    />
                  </Box>
                  <Box mt={3}>
                    <TextField
                      id="description"
                      value={field.description}
                      label="Description"
                      name="description"
                      variant="outlined"
                      fullWidth
                      required
                      onChange={(e) => setField({ ...field, description: e.target.value })}
                      inputProps={{ maxLength: 50 }}
                      helperText="Tell customers what this field is about. e.g. Filling is what goes between cake layers."
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => {
                props.onChange(field);
                handleClose();
              }}
            >
              SAVE
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </span>
  );
}
